import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/collections/260596-crypto-com-app',
    name: 'CryptoApp',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/collections/CryptoApp.vue')
  },
  {
    path: '/collections/10821904-crypto-com-level-up-experience',
    name: 'CryptoLevel',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/collections/CryptoLevel.vue')
  },
  {
    path: '/collections/260584-crypto-com-prepaid-card',
    name: 'CryptoPrepaid',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/collections/CryptoPrepaid.vue')
  },
  {
    path: '/collections/13179648-crypto-com-visa-signature-credit-card-us-only',
    name: 'CryptoCredit',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/collections/CryptoCredit.vue')
  },
  {
    path: '/collections/3488994-crypto-com-cash-account',
    name: 'CryptoCash',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/collections/CryptoCash.vue')
  },
  {
    path: '/collections/12137901-crypto-com-cash-earn-account',
    name: 'CryptoEarn',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/collections/CryptoEarn.vue')
  },
  {
    path: '/collections/19013313-crypto-com-cash-yield-account',
    name: 'CryptoYield',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/collections/CryptoYield.vue')
  },
  {
    path: '/collections/2031951-crypto-com-exchange',
    name: 'CryptoExchange',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/collections/CryptoExchange.vue')
  },
  {
    path: '/collections/9971368-crypto-com-exchange-hk',
    name: 'CryptoExchangeH',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/collections/CryptoExchangeH.vue')
  },
  {
    path: '/collections/2221157-crypto-com-onchain',
    name: 'CryptoOnChain',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/collections/CryptoOnChain.vue')
  },
  {
    path: '/collections/10959614-stocks-etfs',
    name: 'CryptoOnStocks',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/collections/CryptoStocks.vue')
  },
  {
    path: '/collections/16577793-crypto-com-iras',
    name: 'CryptoIRAs',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/collections/CryptoIRAs.vue')
  },
  {
    path: '/collections/1797283-crypto-com-pay-app-faq',
    name: 'CryptoFaq',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/collections/CryptoFaq.vue')
  },
  {
    path: '/collections/3412419-crypto-com-price',
    name: 'CryptoPrice',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/collections/CryptoPrice.vue')
  },
  {
    path: '/collections/2825200-crypto-com-tax',
    name: 'CryptoTax',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/collections/CryptoTax.vue')
  },
  {
    path: '/collections/2852834-crypto-com-nft',
    name: 'CryptoNft',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/collections/CryptoNft.vue')
  },
  {
    path: '/collections/8287455-crypto-com-prime',
    name: 'CryptoPrime',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/collections/CryptoPrime.vue')
  },
  {
    path: '/collections/2012545-kyc-know-your-customer',
    name: 'CryptoCustomer',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/collections/CryptoCustomer.vue')
  },
  {
    path: '/collections/1512001-crypto-com-pay-for-business-merchant-faq',
    name: 'CryptoBusiness',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/collections/CryptoBusiness.vue')
  },
  {
    path: '/collections/3732417-crypto-com-shop',
    name: 'CryptoShop',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/collections/CryptoShop.vue')
  },
  {
    path: '/collections/260617-our-company',
    name: 'CryptoCompany',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/collections/CryptoCompany.vue')
  },
  {
    path: '/collections/2825244-security',
    name: 'CryptoSecurity',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/collections/CryptoSecurity.vue')
  },
  {
    path: '/collections/10284375-crypto-com-web',
    name: 'CryptoWeb',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/collections/CryptoWeb.vue')
  },
  {
    path: '/collections/11261898-crypto-com-custody',
    name: 'CryptoCustody',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/collections/CryptoCustody.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
